import React, { useState } from 'react'
import Button from './Button'
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function Input(props) {

  const [error, setError] = useState()
  const [errorMsg, setErrorMsg] = useState()

  let classProps = ['input__wrap']
  if (props.disabled) {classProps.push('input__wrap--disabled')}
  if (props.className) {classProps.push(props.className)}
  if (error) {classProps.push('input__wrap--error')}
  if (props.type === "search") {classProps.push('input__wrap--search')}

  let inputProps = {
    type: props.type ? props.type : "text",
    className: (props.type === "search") ? "input search" : "input",
    id: props.id ? props.id : props.name,
    name: props.name
  }
  inputProps.value = props.value ?  props.value : ""
  if (props.min) {inputProps.min = props.min}
  if (props.max) {inputProps.max = props.max}
  if (props.step) {inputProps.step = props.step}
  if (props.disabled) {inputProps.disabled = props.disabled}
  if (props.readonly) {inputProps.readonly = props.readonly}
  if (props.required) {
    inputProps.required = props.required
    inputProps.onBlur = () => validate()
  }
  if (props.minlength) {inputProps.minlength = props.minlength}
  if (props.maxlength) {inputProps.maxlength = props.maxlength}
  if (props.placeholder) {inputProps.placeholder = props.placeholder}
  if (props.accept) {inputProps.accept = props.accept}
  if (props.onChange) {inputProps.onChange = props.onChange}
  if (props.onBlur) {inputProps.onBlur = props.onBlur}

  const onSearch = props.onSearch? props.onSearch : function(){}

  function validate() {
    if (props.value === "") {
      setError(true)
      setErrorMsg("This field is required")
    } else {
      setError(false)
      setErrorMsg()
    }
  }

  return (
  <div className={classProps.join(' ')} >
    {props.noLabel? "" : 
      <label className="input__label" htmlFor={props.id ? props.id : props.name}>
        {props.label ? props.label : props.name}: {inputProps.required ? <span className="small">[Required]</span> : ""}
      </label>
    }
    <input 
      {...inputProps}
      />
    {(props.type === "search") ? <Button action="primary" className="input__search-button" onClick={onSearch}>
      <FontAwesomeIcon icon={faSearch} className="input__icon" />
    </Button> : ""}
    {error ? <span className="input__error">{errorMsg}</span> : ""}
  </div>
)}

export default Input